import { BUCKET_WIDTH, bucketScore, display } from '../lib/score.js'

/**
 * The community's scores, in 21 half-point buckets (PLAN §11.2 aggregates).
 *
 * Half points rather than tenths because a bar chart of 101 columns is a
 * texture, not a distribution. The bucket width comes from the API so the
 * server can change it without this file becoming wrong.
 *
 * Drawn as one `img` for a screen reader rather than 21 unlabelled divs: the
 * shape is the information, and reading out twenty-one numbers is not it.
 */
export default function Histogram({ data = [], count = 0, mean = null, bucketWidth = BUCKET_WIDTH }) {
  const buckets = data.length ? data : []
  const peak = Math.max(0, ...buckets)

  if (!count || !peak) {
    return (
      <p className="subtle histogram-empty">
        No scores yet. Yours would be the first.
      </p>
    )
  }

  const summary =
    `Distribution of ${count} rating${count === 1 ? '' : 's'} from 0 to 10` +
    (mean == null ? '' : `, averaging ${display(mean)}`)

  return (
    <div>
      <div className="histogram" role="img" aria-label={summary}>
        {buckets.map((n, i) => (
          <div
            key={i}
            className={`histogram-bar${n === peak ? ' hot' : ''}`}
            style={{ height: `${Math.max(2, (n / peak) * 100)}%` }}
            title={`${display(bucketScore(i) * (bucketWidth / BUCKET_WIDTH))}: ${n} ${
              n === 1 ? 'rating' : 'ratings'
            }`}
          />
        ))}
      </div>
      <div className="histogram-axis" aria-hidden="true">
        <span>0</span>
        <span>2.5</span>
        <span>5.0</span>
        <span>7.5</span>
        <span>10</span>
      </div>
    </div>
  )
}
